import { render, staticRenderFns } from "./GroupedInputText.vue?vue&type=template&id=3973866c&scoped=true&"
import script from "./GroupedInputText.vue?vue&type=script&lang=js&"
export * from "./GroupedInputText.vue?vue&type=script&lang=js&"
import style0 from "./GroupedInputText.vue?vue&type=style&index=0&id=3973866c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3973866c",
  null
  
)

export default component.exports